import PreFooter from '@/next/components/PreFooter/PreFooter';

export default PreFooter;
